import React, { useState, useEffect } from "react";
import classNames from "classnames";
import UserDefaultAvatar from "assets/img/user.svg";
import DefaultTeamAvatar from "assets/img/HandsColorAvatar.jpeg";
import CustomButton from "components/CustomButton";

export default ({ team, memberCount = 4, selectTeam, activeId }) => {
  const [teamState, setTeamState] = useState({});
  const [role] = useState({ 4: "Member", 3: "Admin", 2: "Super Admin" });

  useEffect(() => {
    const users = [...(team?.users || [])];

    users.length = memberCount;

    setTeamState({
      ...team,
      users,
    });
  }, [team, memberCount]);

  return (
    <div className="microsoftTeamCard teamCard">
      <div
        className={classNames({
          activeMicrosoftTeam: activeId === teamState.id ? true : false,
          "t-single-card": true,
          "text-cente": true,
        })}
      >
        <div>
          <img
            style={{ maxHeight: "150px", height: "100%", minHeight: "150px" }}
            className="t-cover br-6"
            src={teamState?.avatar ?? DefaultTeamAvatar}
            alt="team-cover"
          />
        </div>
        <div className="teams-boxes">
          <div className="t-profile">
            {teamState?.manager?.avatar && (
              <img
                className="t-profile-pic rounded-circle"
                src={teamState?.manager?.avatar ?? UserDefaultAvatar}
                alt="user-name"
              />
            )}

            {!teamState?.manager?.avatar && (
              <span className="manegarNoProfilePicture">
                <span className="manegarNoUserAvatar">
                  {teamState?.manager?.full_name.charAt(0).toUpperCase()}
                </span>
              </span>
            )}
          </div>
          <div className="t-card-content">
            <div className="team-title">{teamState.name}</div>
            <div className="teamText">
              <small className="fs-12 color-light teamText">
                {" "}
                {teamState.latest_topic
                  ? teamState.latest_topic.content
                  : "No current topics"}
              </small>
            </div>
            <div>
              <small>
                Role:{" "}
                <span style={{ fontWeight: "500" }}>{role[team?.role_id]}</span>
              </small>
            </div>
            <div className="joined-users microsoftTeamBodyContent">
              {teamState?.users?.map((user) => (
                <React.Fragment key={user?.id}>
                  <img
                    alt="user-name"
                    src={user?.avatar ?? UserDefaultAvatar}
                    className="stackedImage"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={user?.full_name.toUpperCase()}
                  />
                </React.Fragment>
              ))}
              {teamState?.users_count > memberCount && (
                <span className="stackedImage userName">
                  <span className="userNoProfilePicture">
                    {" "}
                    +{teamState?.users_count - memberCount}{" "}
                  </span>
                </span>
              )}
            </div>
          </div>
          <CustomButton
            type="button"
            name="Select"
            onClick={() => selectTeam(teamState)}
            buttonClass={classNames({
              "microsoft-active-button":
                activeId === teamState.id ? true : false,
              full_w: true,
              "f-left": true,
              "outline-btn": true,
            })}
          />
        </div>
      </div>
    </div>
  );
};
